import { render } from "./OrgPicker.html?vue&type=template&id=03a08078&scoped=true&ts=true"
import script from "./OrgPicker.ts?vue&type=script&lang=ts"
export * from "./OrgPicker.ts?vue&type=script&lang=ts"

import "./OrgPicker.scss?vue&type=style&index=0&id=03a08078&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a08078"]])

export default __exports__